export const SET_IS_LOADING = 'SET_IS_LOADING/purcahse_order'
export const SET_DATA_PAGINATION = 'SET_DATA_PAGINATION/purcahse_order'
export const SET_LAST_PARAMS = 'SET_LAST_PARAMS/purcahse_order'
export const SET_PURCHASE_ORDERS = 'SET_PURCHASE_ORDERS/purcahse_order'
export const SET_SELECTED_PURCHASE_ORDER = 'SET_SELECTED_PURCHASE_ORDER/purcahse_order'
export const SET_PARTIES = 'SET_PARTIES/purcahse_order'
export const SET_PRODUCTS = 'SET_PRODUCTS/purcahse_order'
export const SET_VENDORS = 'SET_VENDORS/purcahse_order'
